// src/constants/index.js
import { DollartIcon, NairaIcon, EmptyIcon } from "assets/svg-code";

export const CURRENCY = process.env.REACT_APP_CURRENCY;

const CURRENCY_MAP = {
    usd: { icon: <DollartIcon width={20} height={20} />, symbol: "$" },
    ngn: { icon: <NairaIcon width={20} height={20} />, symbol: "₦" },
    unit: { icon: <EmptyIcon width={20} height={20} />, symbol: "" },
};

const key = (CURRENCY || "").toLowerCase();
const fallback = CURRENCY_MAP.unit;

export const CURRENCY_ICON = (CURRENCY_MAP[key] || fallback).icon;
export const CURRENCY_STRING = (CURRENCY_MAP[key] || fallback).symbol;
